import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M25.333 32A2.67 2.67 0 0028 29.333v-24a2.67 2.67 0 00-2.667-2.666H22A2.67 2.67 0 0019.333 0h-6.666A2.67 2.67 0 0010 2.667H6.667A2.67 2.67 0 004 5.333v24A2.67 2.67 0 006.667 32h18.666zM12.667 2.667h6.666v2.666h-6.666l-.001-1.325V4 2.667zm-6 2.666H10A2.67 2.67 0 0012.667 8h6.666A2.67 2.67 0 0022 5.333h3.333v24H6.667v-24z"></path>
          <path d="M16 10c-4.043 0-7.333 3.29-7.333 7.333 0 4.044 3.29 7.334 7.333 7.334s7.333-3.29 7.333-7.334C23.333 13.29 20.043 10 16 10zm4.47 6h-3.137v-3.137A4.682 4.682 0 0120.47 16zM16 22a4.672 4.672 0 01-4.667-4.667 4.673 4.673 0 013.334-4.47v4.47c0 .736.597 1.334 1.333 1.334h4.47A4.673 4.673 0 0116 22z"></path>
        </svg>
    );
}